export default "__VITE_ASSET__a30c504e__"